import { Button, Modal, ModalBody } from "reactstrap";
import { dummyTermsAndConditions } from "../../dummyData";
import { RxCross2 } from "react-icons/rx";
import { useTranslation } from "../../languages";

const TermsAndConditions = ({ modalOpen, setModalOpen }) => {
  const { t } = useTranslation();
  return (
    <Modal
      centered
      size="lg"
      isOpen={modalOpen}
      toggle={() => setModalOpen((prev) => !prev)}
    >
      <ModalBody className="bg-white p-4" style={{ borderRadius: "28.24px" }}>
        <div className="d-flex align-items-center mb-4 justify-content-between">
          <Button
            onClick={() => setModalOpen(false)}
            className="p-0 bg-primary-blue full-rounded border-none"
            style={{ height: 44, width: 44, aspectRatio: 1 }}
          >
            <RxCross2 strokeWidth={`1px`} size={20} />
          </Button>
          <h3 className="f-6  figma-shadowed-black-text m-0 ">
            {t("termsAndConditions")}
          </h3>
          <div style={{ height: 44, width: 44 }}></div>
        </div>
        <p className="f-4">{t("termsWelcome")}</p>
        <div>
          {dummyTermsAndConditions?.map((item, key) => (
            <div key={key}>
              <h6 className="f-5">
                {key + 1}
                {" . "}
                {t(`termsTitle${key + 1}`)}
              </h6>
              <p className="f-4" style={{ color: "rgba(0, 0, 0, 0.6)" }}>
                {t(`termsParagraph${key + 1}`)}
              </p>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default TermsAndConditions;
